<template>
    <div>
      <Head title="Job Reports" />
      <div class="mb-8 mt-2 d-flex align-center justify-space-between">
        <h1 class="text-3xl font-bold">Job Reports</h1>
        <downloadexcel
          :data="jobs"
          :fields="job_fields"
          :name="'job-report-' + formatDate(new Date())"
        >
          <v-btn x-large color="primary" class="ml-4">Download <v-icon>mdi-download</v-icon></v-btn>
        </downloadexcel>
      </div>

      <v-card class="mb-6">
        <v-card-title>Search Jobs</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startDate"
                    label="Start Publishing Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  @input="startDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="endDate"
                    label="End Publishing Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  @input="endDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-btn color="primary" @click="searchJobs" :loading="loading">Search</v-btn>
        </v-card-text>
      </v-card>

      <v-data-table
        :items="jobs"
        :headers="headers"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100]
        }"
      >
        <template v-slot:item.title="{ item }">
          <a :href="`/job/${item.alias}`" target="_blank">{{ item.title }}</a>
        </template>
        <template v-slot:item.remote_type="{ item }">
          <v-chip v-if="item.remote_type" color="primary" small>{{ item.remote_type }}</v-chip>
          <span v-else>No</span>
        </template>
        <template v-slot:item.stop_publishing="{ item }">
          {{ formatDate(item.stop_publishing) }}
        </template>
      </v-data-table>

    </div>
  </template>

  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import { Link } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyAdminLayout'
  import axios from 'axios'
  import downloadexcel from "vue-json-excel";

  export default {
    components: {
      Head,
      downloadexcel,
      Link
    },
    props: {
      initialJobs: {
        type: Array,
        default: () => []
      }
    },
    data: () => ({
      jobs: [],
      loading: false,
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
      headers: [
        { text: 'Company', value: 'organization.name' },
        { text: 'Job Title', value: 'title' },
        { text: 'Contract Type', value: 'contract_type' },
        { text: 'Remote Work?', value: 'remote_type' },
        { text: 'Region', value: 'region' },
        { text: 'Start Date', value: 'start_publishing' },
        { text: 'Stop  Date', value: 'stop_publishing' }
      ],
      job_fields: {
        "Company": "organization.name",
        "Job Title": "title",
        "Contract Type": "contract_type",
        "Remote Work": "remote_type",
        "Region": "region",
        "Start Publishing Date": {
          field: "start_publishing",
          callback: (value) => {
            if (!value) return '';
            const d = new Date(value);
            return d.toLocaleDateString('en-IE', { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric' 
            });
          }
        },
        "Stop Publishing Date": {
          field: "stop_publishing",
          callback: (value) => {
            if (!value) return '';
            const d = new Date(value);
            return d.toLocaleDateString('en-IE', { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric' 
            });
            
          },
          
         
        },
          "Job Hyperlink": {
            field: "alias",
            callback: (alias) => `=HYPERLINK("https://backtoworkconnect.ie/job/${alias}", "${alias}")`
          }
      },
    }),
    layout: Layout,
    mounted() {
      // Don't load anything initially as per requirements
    },
    methods: {
      formatDate(date) {
        if (!date) return '';
        const d = new Date(date);
        return d.toLocaleDateString('en-IE', { 
          year: 'numeric', 
          month: 'short', 
          day: 'numeric' 
        });
      },
      searchJobs() {
        this.loading = true;
        axios.get('/admin/reports/filteredJobSearch', {
          params: {
            start_date: this.startDate,
            end_date: this.endDate
          }
        })
        .then(response => {
          this.jobs = response.data;
          this.loading = false;
        })
        .catch(error => {
          console.error('Error fetching jobs:', error);
          this.loading = false;
        });
      }
    }
  }
  </script>

  <style scoped>
    .v-sheet--offset {
      top: -24px;
      position: relative;
    }
  </style>
